const serialize = (obj) => JSON.stringify(obj)

export default serialize
